import React from 'react';
import { CardHeader, Typography, CardActions, Grid, Button, Box, Card } from '@mui/material';
import moment from 'moment';
import CheckIcon from '@mui/icons-material/Check';
import { Virtuoso } from 'react-virtuoso';

const NotificationCard = ({ data, markAsRead, showDetails, showMarkNotificationAsReadButton }) => (
  <Card variant="outlined">
    <CardHeader
      disableTypography
      onClick={() => showDetails(data.id)}
      title={
        <Typography gutterBottom sx={{ lineHeight: 1.2 }} component="p" variant="subtitle1">
          {data.subject}
        </Typography>
      }
      subheader={
        <Typography component="p" variant="body2" color="textSecondary">
          {moment(data.created_at).format('MM/DD/YYYY h:mm A')}
        </Typography>
      }
    />

    {showMarkNotificationAsReadButton && (
      <CardActions disableSpacing>
        <Button
          startIcon={<CheckIcon />}
          variant="contained"
          color="primary"
          aria-label="mark as read"
          onClick={() => markAsRead(data.id)}
        >
          Mark as read
        </Button>
      </CardActions>
    )}
  </Card>
);

const NotificationsCardList = ({
  isLoading,
  notifications,
  markAsRead,
  goToNotificationDetails,
  showMarkNotificationAsReadButton,
}) => (
  <Grid container direction="column" justifyContent="center" alignItems="stretch" sx={{ height: '100%' }}>
    {!isLoading && notifications.length === 0 && (
      <Grid item xs>
        Congratulations! You're all caught up on your notifications ✅
      </Grid>
    )}
    {!isLoading && notifications.length > 0 && (
      <Virtuoso
        style={{ width: '100%', height: '100%' }}
        totalCount={notifications.length}
        itemContent={index => {
          const top = index === 0 ? 0 : 2;
          const bottom = index === notifications.length ? 0 : 2;
          const notification = notifications[index];
          return (
            <Grid item xs key={notification.id}>
              <Box mt={top} mb={bottom}>
                <NotificationCard
                  showDetails={goToNotificationDetails}
                  markAsRead={markAsRead}
                  data={notification}
                  showMarkNotificationAsReadButton={showMarkNotificationAsReadButton}
                />
              </Box>
            </Grid>
          );
        }}
      />
    )}
  </Grid>
);

export default NotificationsCardList;
